name: Flipper icons pack
author: Flipper devices inc.
link: 
license: 
sort: dimensions
source: ../assets/img/flipper
